
module.config(function($stateProvider) {

    $stateProvider.state('student.americorps', {
        abstract: true,
        url: '/americorps',
        permission: 'viewAmericorpsSlots',
        templateUrl: 'empty',
    });

    $stateProvider.state('student.americorps.index', {
        url: '',
        templateUrl: 'students/americorps/index',
        controller: 'SlotIndexController',
        controllerAs: 'ctrl',
        resolve: {
            auth: function($checkPermissions, program, student, permissions) {
                if (program.ever_amc && (student.has_enrollment || student.slots > 0)) {
                    return true;
                }
                return $checkPermissions('administerStudents', permissions);
            },
            slots: function(ModelService, student) {
                return ModelService.getRelation('participant', student.id, 'slots');
            },
        },
    });

    $stateProvider.state('student.americorps.slot', {
        url: '/{slotId:int}',
        templateUrl: 'students/americorps/slot',
        resolve: {
            slot: function($stateParams, ModelService, student) {
                return ModelService.get('americorps_slot', $stateParams.slotId)
                    .then(ModelService.assertRelation('participant_id', student.id));
            },
        },
        controller: 'AmericorpsSlotController',
    });

});


module.filter('amcMonthHours', function(moment) {
    return function(startDate, daysSuspended) {
        var endDate, months, count, i;
        if (!startDate) return [];

        months = [];
        daysSuspended = daysSuspended || 0;
        startDate = moment(startDate);
        endDate = moment(startDate).add(12, "months")
            .add(daysSuspended, 'days');

        endDate = moment.min(moment(), endDate);

        count = 12 * (endDate.year() - startDate.year()) +
            (endDate.month() - startDate.month()) + 1;

        for (i = 0; i < count; i++) {
            months.push(startDate.format('MMMM YYYY'));
            startDate.add(1, 'month');
        }

        return months;
    };
});